import { Test, TestType } from '../../parser/models/all.js';
import { isOnlyField } from '../../parser/utils/testOnlyUtils.js';
import { PostProcessContext } from '../models/postProcessContext.js';
import { applyOnlyExpression } from './postProcessUtils.js';

/**
 * Post-processor that handles 'only' metadata. 
 * If a test or an 'only' literal field is encountered, it applies the filter to the surrounding tests.
 * 
 * @param test - The test or field to check for 'only' metadata.
 * @param index - The current index in the pre-tests collection.
 * @param context - The post-processing context. 
 * @returns True if the item was an 'only' literal field and should be removed from the final collection.
 */
export function processHasOnly(test: Test, index: number, context: PostProcessContext): boolean {
  if (test.type.has(TestType.HAS_ONLY) === false) {
    return false;
  }

  if (test.type.is(TestType.OBJECT_WITH_ONLY) === false) {

    applyOnlyExpression(
      test,
      index,
      context.preTests
    );

    return false;
  }

  // check if this is an only field
  if (isOnlyField(test.name, context.options) === false) return false;

  // get the next object or function test
  const nextIndex = index + 1;
  const nextTest = context.nextHasEither(
    nextIndex,
    TestType.OBJECT,
    TestType.FUNCTION
  );

  if (nextTest !== null) {
    nextTest.groupName = test.groupName;
    nextTest.type.value |= TestType.HAS_ONLY;
    nextTest.onlyExpression = test.onlyExpression;

    applyOnlyExpression(
      test,
      nextIndex,
      context.preTests
    );
  }

  // prevent the only field from further processing
  return true;
}